import React, { ReactNode } from 'react'
import { Box, Grid, Typography } from '@mui/material'
import { BannerBox, ContentBox, DescriptionText, SectionCard } from './styles'

interface FormFieldSectionProps {
  description?: ReactNode
  label?: ReactNode
  children: ReactNode
}

/**
 * Envuelve un campo de formulario (texto, listado, radio, checkbox, etc.) con
 * un título opcional a la izquierda (layout de 2 columnas) y un texto de
 * ayuda opcional arriba. No conoce ni depende del tipo de campo que recibe
 * como `children`.
 *
 * - Con `description`: encierra todo el bloque en una tarjeta (banner celeste
 *   con la barra izquierda + el campo en fondo blanco).
 * - Sin `description`: solo aplica el layout de 2 columnas, sin tarjeta.
 */
export const FormFieldSection: React.FC<FormFieldSectionProps> = ({
  description,
  label,
  children
}) => {
  const content = (
    <Grid container spacing={1.5} alignItems='center'>
      {label && (
        <Grid item xs={12} sm={4}>
          <Typography variant='subtitle2'>{label}</Typography>
        </Grid>
      )}
      <Grid item xs={12} sm={label ? 8 : 12}>
        {children}
      </Grid>
    </Grid>
  )

  if (!description) {
    return <Box mb={2}>{content}</Box>
  }

  return (
    <SectionCard>
      <BannerBox>
        <DescriptionText variant='body2'>{description}</DescriptionText>
      </BannerBox>
      <ContentBox>{content}</ContentBox>
    </SectionCard>
  )
}
